var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65282 10.3802C7.93618 10.6823 7.92097 11.1569 7.61885 11.4403L5.79535 13.1506C4.28473 14.5673 4.20867 16.9405 5.62547 18.4511C7.04227 19.9617 9.41541 20.0378 10.926 18.621L12.7495 16.9107C13.0516 16.6274 13.5263 16.6426 13.8096 16.9447C14.093 17.2468 14.0778 17.7215 13.7757 18.0048L11.9522 19.7151C9.8373 21.6986 6.5149 21.5921 4.53138 19.4772C2.54786 17.3624 2.65434 14.04 4.76921 12.0565L6.59271 10.3462C6.89483 10.0629 7.36946 10.0781 7.65282 10.3802Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7925 4.5314C14.9074 2.54787 18.2298 2.65435 20.2133 4.76923C22.1969 6.88411 22.0904 10.2065 19.9755 12.19L18.152 13.9003C17.8499 14.1836 17.3753 14.1684 17.0919 13.8663C16.8086 13.5642 16.8238 13.0895 17.1259 12.8062L18.9494 11.0959C20.46 9.67915 20.5361 7.30599 19.1193 5.79537C17.7025 4.28474 15.3293 4.20869 13.8187 5.62549L11.9952 7.33572C11.6931 7.61908 11.2184 7.60387 10.9351 7.30175C10.6517 6.99962 10.6669 6.52499 10.969 6.24163L12.7925 4.5314Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0303 9.46971C15.3232 9.76261 15.3232 10.2375 15.0303 10.5304L10.5303 15.0303C10.2374 15.3232 9.76254 15.3232 9.46965 15.0303C9.17676 14.7374 9.17676 14.2626 9.46965 13.9697L13.9697 9.46971C14.2626 9.17682 14.7374 9.17682 15.0303 9.46971Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnected);
export default __webpack_public_path__ + "static/media/connected.4429ec30.svg";
export { ForwardRef as ReactComponent };